// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"57":"erp-chart-container","216":"vendors","978":"price-chart"}[chunkId] + "." + {"57":"003cbfca3ce40296002e","216":"d955b7761406d5e06dfd","978":"83e58c1d9255ebc30c8b"}[chunkId] + ".js";
};